// Análise por Departamento (Gestão Orçamentária): mesmo módulo de Custos/Despesas Gerais e
// Custo/Despesas Mão de Obra, só reagrupado por departamento em vez de por grupo — nunca tem
// formulário próprio, todo valor vem agregado dos módulos de origem (ver
// backend/services/analise_departamento_svc.py).
// Espelha backend/config.py ROLES_ANALISE_DEPARTAMENTO — mantenha os dois em sincronia.
export const ROLES_ANALISE_DEPARTAMENTO = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
